import { useRef, useState } from 'react';
import classNames from 'classnames';
import {
  Modal,
  Button,
  FlexContainer,
  Txt,
  CirclePicture,
  ContentBlock,
  Icon,
  TenantAddEdit,
} from 'components';
import { ModalGlobal } from 'lib/ModalContext';
import styles from './InputTenants.module.scss';

/**
 * InputTenants
 *
 * @return {JSX.Element}
 */
const InputTenants = ({
  className,
  disabled,
  name,
  value,
  onChange,
  reverse,
  required,
}) => {
  const buttonRef = useRef();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const handleEdit = (tenant) => () => setIsOpen(tenant);
  const handleHiddenInputFocus = (e) => {
    console.log(e);
    buttonRef.current?.focus();
  };

  const handleSave = (newData) => {
    if (isOpen === true) {
      onChange({ target: { name, value: [...value, newData] } });
    } else {
      const idx = value.indexOf(isOpen);
      const newValue = [...value];
      newValue[idx] = newData;
      onChange({ target: { name, value: newValue } });
    }
    handleClose();
  };

  const handleDeleteTenant = (tenant) => (e) => {
    // Prevent edit open
    e.preventDefault();
    e.stopPropagation();

    const idx = value.indexOf(tenant);
    if (idx >= 0) {
      const newValue = [...value];
      newValue.splice(idx, 1);
      onChange({ target: { name, value: newValue } });
    }
  };

  return (
    <FlexContainer
      className={classNames(
        styles.InputTenants,
        className,
        InputTenants.displayName
      )}
      column
      gap
    >
      <input
        className={styles.HiddenInput}
        type="text"
        name={name}
        value={value?.length || ''}
        onChange={() => {}}
        required={required}
        onFocus={handleHiddenInputFocus}
        tabIndex={0}
      />
      {value?.length ? (
        <FlexContainer gap wrap>
          {value.map((t, idx) => (
            <ContentBlock alignCenter key={idx} gap onClick={handleEdit(t)}>
              <CirclePicture fullText={`${t.firstName} ${t.lastName}`} />
              <FlexContainer column gapQuad>
                <Txt>
                  {t.title} {t.firstName} {t.lastName}
                </Txt>
                <Txt regular>{t.emailAddress}</Txt>
              </FlexContainer>
              <FlexContainer>
                <Icon name="close" onClick={handleDeleteTenant(t)} />
              </FlexContainer>
            </ContentBlock>
          ))}
        </FlexContainer>
      ) : null}
      <Button
        ref={buttonRef}
        onClick={handleOpen}
        flex
        className={styles.Button}
        disabled={disabled}
        big
        reverse={reverse}
      >
        <FlexContainer spaceBetween alignCenter flex>
          <Txt xx>Add a Tenant</Txt>
          <Icon name="plus" />
        </FlexContainer>
      </Button>
      {isOpen ? (
        <ModalGlobal>
          <Modal onClose={handleClose} noPadding>
            <TenantAddEdit
              tenant={isOpen === true ? undefined : isOpen}
              onSave={handleSave}
            />
          </Modal>
        </ModalGlobal>
      ) : null}
    </FlexContainer>
  );
};

InputTenants.displayName = 'InputTenants';

export default InputTenants;
